export const hzLayoutFlatData = [
  {
    "routePath": "/",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/components/global-layout-wrap/register.js"
  },
  {
    "routePath": "/",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "globalPageLayout": true,
      "noCheckPermission": true
    }
  },
  {
    "routePath": "/app-self-support-order",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/components/project-layout-wrap/register.js",
    "hzLayoutOption": {}
  },
  {
    "routePath": "/app-self-support-order/customer",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-NZSU"
      }
    }
  },
  {
    "routePath": "/app-self-support-order/customer/new-group-msg",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "客户查询",
            "path": "/app-self-support-order/customer"
          },
          {
            "name": "发送消息"
          }
        ],
        "title": "创建群发"
      }
    }
  },
  {
    "routePath": "/app-self-support-order",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js"
  },
  {
    "routePath": "/app-self-support-order/order-import",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-pnSp"
      }
    }
  },
  {
    "routePath": "/app-self-support-order/order-manage",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-IgZU"
      }
    }
  },
  {
    "routePath": "/app-self-support-order/setting",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-oqcV"
      }
    }
  },
  {
    "routePath": "/app-self-support-order/shop-manage",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-J0yj"
      }
    }
  },
  {
    "routePath": "/company-management/base-menu",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "noUseGlobalLayoutComponent": true,
      "noCheckPermission": true,
      "pageHeaderOption": {
        "contentType": "title",
        "title": "菜单管理"
      }
    }
  },
  {
    "routePath": "/company-management/management",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "noUseGlobalLayoutComponent": true,
      "noCheckPermission": true,
      "pageHeaderOption": {
        "content": [
          {
            "name": "商家管理",
            "tabKey": "management",
            "hzHelp": "",
            "title": "商家管理"
          },
          {
            "name": "失败记录",
            "tabKey": "failed-list",
            "hzHelp": "",
            "title": "失败记录"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/components/project-layout-wrap/register.js",
    "hzLayoutOption": {}
  },
  {
    "routePath": "/crm/authorization/work-weixin",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-dM9d"
      }
    }
  },
  {
    "routePath": "/crm/autotask/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "自动群发",
            "path": "/crm/autotask"
          },
          {
            "name": "群发明细"
          }
        ],
        "title": "群发明细"
      }
    }
  },
  {
    "routePath": "/crm/autotask",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "自动群发记录",
            "tabKey": "record",
            "title": "自动群发记录"
          },
          {
            "name": "自动群发配置",
            "tabKey": "setting",
            "title": "自动群发配置"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/company-information",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title"
      }
    }
  },
  {
    "routePath": "/crm/company-moments",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "朋友圈统计",
            "tabKey": "1",
            "title": "朋友圈统计"
          },
          {
            "name": "朋友圈页面",
            "tabKey": "2",
            "title": "朋友圈页面"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/company-moments/interaction-ranking",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "朋友圈统计",
            "path": "/crm/company-moments"
          },
          {
            "name": "互动排行"
          }
        ],
        "title": "互动排行"
      }
    }
  },
  {
    "routePath": "/crm/company-moments/moments/create-moment",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "企业朋友圈",
            "path": "/crm/company-moments"
          },
          {
            "name": "创建朋友圈"
          }
        ],
        "title": "创建朋友圈"
      }
    }
  },
  {
    "routePath": "/crm/customer-grouping/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "客户分组",
            "path": "/crm/customer-grouping"
          },
          {
            "name": "客户详情"
          }
        ],
        "title": "客户分组-客户详情"
      }
    }
  },
  {
    "routePath": "/crm/customer-grouping",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-pd8s"
      }
    }
  },
  {
    "routePath": "/crm/customer-management/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "客户管理",
            "path": "/crm/customer-management"
          },
          {
            "name": "客户详情"
          }
        ],
        "title": "客户管理-客户详情"
      }
    }
  },
  {
    "routePath": "/crm/customer-management",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "客户管理",
            "tabKey": "search",
            "title": "客户管理"
          },
          {
            "name": "扩展资料",
            "tabKey": "custom-field",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-Ubdi",
            "title": "扩展资料"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/customer-warning",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title"
      }
    }
  },
  {
    "routePath": "/crm/drainage-channel-code-manage",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "渠道引流配置",
            "tabKey": "1",
            "hzHelp": "",
            "title": "渠道引流配置"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/drainage-channel-manage",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "渠道管理",
            "tabKey": "drainage_channel_manage",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-9vah",
            "title": "渠道管理"
          },
          {
            "name": "裂变渠道",
            "tabKey": "fission_channel_manage",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-1VQf",
            "title": "裂变渠道"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/drainage-channel-stat",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title"
      }
    }
  },
  {
    "routePath": "/crm/drainage-contact-me/create",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "联系我",
            "path": "/crm/drainage-contact-me"
          },
          {
            "name": "创建联系我"
          }
        ],
        "title": "创建联系我"
      }
    }
  },
  {
    "routePath": "/crm/drainage-contact-me/export-material",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "联系我",
            "path": "/crm/drainage-contact-me"
          },
          {
            "name": "导出物料"
          }
        ],
        "title": "导出物料"
      }
    }
  },
  {
    "routePath": "/crm/drainage-contact-me",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-RS5W"
      }
    }
  },
  {
    "routePath": "/crm/drainage-welcome-sentence",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "渠道欢迎语",
            "tabKey": "channel_welcome",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-UG9u",
            "title": "渠道欢迎语"
          },
          {
            "name": "员工欢迎语",
            "tabKey": "employee_welcome",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-0XXk",
            "title": "员工欢迎语"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/duplicate-customer",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-pNmj"
      }
    }
  },
  {
    "routePath": "/crm/fission",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "客户裂变",
            "tabKey": "drainage_channel_manage",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-xDiq",
            "title": "客户裂变"
          },
          {
            "name": "裂变数据",
            "tabKey": "fission_channel_manage",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-yASl",
            "title": "裂变数据"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/group-bulk",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-RXRg"
      }
    }
  },
  {
    "routePath": "/crm/group-bulk/new-group-bulk",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "客户群群发",
            "path": "/crm/group-bulk"
          },
          {
            "name": "发送消息"
          }
        ],
        "title": "创建群发",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-BCta"
      }
    }
  },
  {
    "routePath": "/crm/group-grouping",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-IY7n"
      }
    }
  },
  {
    "routePath": "/crm/group-list/group-member",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "群列表",
            "path": "/crm/group-list"
          },
          {
            "name": "详情"
          }
        ],
        "title": "群详情"
      }
    }
  },
  {
    "routePath": "/crm/group-list",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-7DAg"
      }
    }
  },
  {
    "routePath": "/crm/group-msg/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "群发记录",
            "path": "/crm/group-msg"
          },
          {
            "name": "群发明细"
          }
        ],
        "title": "群发明细"
      }
    }
  },
  {
    "routePath": "/crm/group-msg",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-RXRg"
      }
    }
  },
  {
    "routePath": "/crm/group-msg/new-group-msg",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "客户管理",
            "path": "/crm/customer-management"
          },
          {
            "name": "发送消息"
          }
        ],
        "title": "创建群发",
        "hzHelp": "https://shimo.im/docs/xtm3YYjIkdQslN8c#anchor-BCta"
      }
    }
  },
  {
    "routePath": "/crm/group-sop",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-hZG1"
      }
    }
  },
  {
    "routePath": "/crm/group-sop/info",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "群SOP",
            "path": "/crm/group-sop"
          },
          {}
        ],
        "title": "群SOP"
      }
    }
  },
  {
    "routePath": "/crm/group-sop/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "群SOP",
            "path": "/crm/group-sop"
          },
          {}
        ],
        "title": "群SOP"
      }
    }
  },
  {
    "routePath": "/crm/home",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG"
      }
    }
  },
  {
    "routePath": "/crm/lost-customer/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": []
      }
    }
  },
  {
    "routePath": "/crm/lost-customer",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "删除客户",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-p17a",
            "title": "删除客户"
          },
          {
            "name": "被删除",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-dg3p",
            "title": "被删除"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/material",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-sIPv"
      }
    }
  },
  {
    "routePath": "/crm/role-permission",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-o0YY"
      }
    }
  },
  {
    "routePath": "/crm/stat-contact-customer",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "content": {
          "descriptionOption": {
            "popoverOption": {
              "placement": "rightTop"
            }
          }
        },
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-qrCK"
      }
    }
  },
  {
    "routePath": "/crm/stat-customer",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "客户统计",
            "tabKey": "stat",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-rdWh",
            "title": "客户统计"
          },
          {
            "name": "客户分布",
            "tabKey": "distribution",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-GCbS",
            "title": "客户分布"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/stat-resign",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title"
      }
    }
  },
  {
    "routePath": "/crm/store-management",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "title": "门店管理"
      }
    }
  },
  {
    "routePath": "/crm/tag-create-group/create",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "title": "发送消息"
      }
    }
  },
  {
    "routePath": "/crm/tag-create-group/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "标签建群",
            "path": "/crm/tag-create-group"
          },
          {
            "name": "明细"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/tag-create-group",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title"
      }
    }
  },
  {
    "routePath": "/crm/task-management/detail/:id",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "任务管理",
            "path": "/crm/task-management"
          },
          {
            "name": "详情"
          }
        ],
        "title": "任务详情"
      }
    }
  },
  {
    "routePath": "/crm/task-management",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title"
      }
    }
  },
  {
    "routePath": "/crm/task-management/task",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "breadcrumb",
        "content": [
          {
            "name": "任务管理",
            "path": "/crm/task-management"
          },
          {}
        ]
      }
    }
  },
  {
    "routePath": "/crm/task-stat-manage",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "员工统计",
            "tabKey": "staff_stat",
            "hzHelp": "",
            "title": "员工统计"
          }
        ]
      }
    }
  },
  {
    "routePath": "/crm/team-management",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-Skfb"
      }
    }
  },
  {
    "routePath": "/message-control",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/components/project-layout-wrap/register.js",
    "hzLayoutOption": {}
  },
  {
    "routePath": "/message-control/kpi",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "客服考核统计",
            "tabKey": "1",
            "hzHelp": "",
            "title": "客服考核统计"
          },
          {
            "name": "规则配置",
            "tabKey": "2",
            "hzHelp": "",
            "title": "规则配置"
          }
        ]
      }
    }
  },
  {
    "routePath": "/message-control/message-history",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "私聊",
            "tabKey": "chat",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-dC8a",
            "title": "消息查询-私聊"
          },
          {
            "name": "群聊",
            "tabKey": "group-chat",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-dC8a",
            "title": "消息查询-群聊"
          }
        ]
      }
    }
  },
  {
    "routePath": "/message-control/message-monitor",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "私聊",
            "tabKey": "chat",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-EZ4E",
            "title": "消息跟踪-私聊"
          },
          {
            "name": "群聊",
            "tabKey": "group-chat",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-EZ4E",
            "title": "消息跟踪-群聊"
          }
        ]
      }
    }
  },
  {
    "routePath": "/message-control/sensitive-behavior",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "tabs",
      "pageHeaderOption": {
        "content": [
          {
            "name": "敏感记录",
            "tabKey": "record",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-f4ae",
            "title": "敏感记录"
          },
          {
            "name": "敏感行为管理",
            "tabKey": "manage",
            "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-f4ae",
            "title": "敏感行为管理"
          }
        ]
      }
    }
  },
  {
    "routePath": "/message-control/sensitive-notification",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-kfjE"
      }
    }
  },
  {
    "routePath": "/message-control/sensitive-words",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-atdN"
      }
    }
  },
  {
    "routePath": "/message-control/session-tag",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "content": {
          "descriptionOption": {
            "popoverOption": {
              "placement": "rightTop"
            }
          }
        },
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-Oyj5"
      }
    }
  },
  {
    "routePath": "/message-control/setting",
    "hzLayoutPath": "/builds/oem/oem-fe-work-manager/src/layouts/auth-layout/register.js",
    "hzLayoutOption": {
      "pageHeaderType": "header",
      "pageHeaderOption": {
        "contentType": "title",
        "hzHelp": "https://shimo.im/docs/3OntfASEWRcvkYzG#anchor-ZcwR"
      }
    }
  }
]
